module.exports = __webpack_public_path__ + "img/career.1158d3a9.jpg";